export const GET_REMAINING_LEAVES_USERS = 'common@remaining-leaves';